import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter your email.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.message || "You're on the list!");
      setEmail("");
    } catch {
      toast.error("Could not subscribe. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-sand pt-24 md:pt-32 pb-12">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start pb-20 border-b border-line">
          <div>
            <h2 className="font-serif font-light text-5xl sm:text-6xl tracking-tight text-forest leading-none">
              Your free daily<br />ritual, every morning.
            </h2>
            <p className="mt-6 text-muted max-w-md">
              Join our list for a free daily wellness ritual delivered to your inbox — gentle
              practices to cleanse, calm and create.
            </p>
          </div>
          <form onSubmit={subscribe} className="lg:pt-4" data-testid="newsletter-form">
            <label className="text-xs tracking-[0.2em] uppercase text-muted">Subscribe</label>
            <div className="mt-3 flex items-center gap-4 border-b border-forest/40 pb-3">
              <input
                data-testid="newsletter-email-input"
                type="email"
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 bg-transparent text-lg focus:outline-none"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="newsletter-submit-btn"
                className="text-forest hover:translate-x-1 transition-transform disabled:opacity-50"
                aria-label="Subscribe"
              >
                <ArrowRight />
              </button>
            </div>
          </form>
        </div>

        <div className="pt-12 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div>
            <p className="font-serif text-2xl text-forest leading-none">Sound Body Retreat</p>
            <p className="text-sm text-muted mt-2">Cleanse · Calm · Create</p>
          </div>
          <div className="flex flex-wrap gap-8 text-sm text-muted">
            <a href="#about" className="hover:text-forest transition-colors">About</a>
            <a href="#pillars" className="hover:text-forest transition-colors">Pillars</a>
            <a href="#quiz" className="hover:text-forest transition-colors">Quiz</a>
            <a href="#retreats" className="hover:text-forest transition-colors">Retreats</a>
            <a href="#contact" className="hover:text-forest transition-colors">Contact</a>
          </div>
        </div>
        <p className="text-xs text-muted mt-12">© {new Date().getFullYear()} Sound Body Retreat. All rights reserved.</p>
      </div>
    </footer>
  );
};
